import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';

const DEFAULT_PAGE_NO = 1;
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_KEY = undefined;
const DEFAULT_CLIENT_ID = undefined;

export const DEFAULT_SORT = 'asc';
export const DEFAULT_SORT_BY = 'no';

const DEFAULT_CATEGORY = undefined;
const DEFAULT_INVEST_LEVEL = undefined;
const DEFAULT_KEYWORD = undefined;
const DEFAULT_TAG = undefined;
const DEFAULT_PRESS_TYPE = undefined;

interface QueryParams {
  pageNo?: number;
  pageSize?: number;
  sort?: string;
  sortBy?: string;
  category?: string;
  investLevel?: string;
  keyword?: string;
  tag?: string;
  pressType?: string;
}

const useQueryString = (queryParams?: QueryParams | undefined | null) => {
  const [query, setQuery] = useQueryParams({
    pageNo: withDefault(NumberParam, queryParams?.pageNo || DEFAULT_PAGE_NO),
    pageSize: withDefault(
      NumberParam,
      queryParams?.pageSize || DEFAULT_PAGE_SIZE
    ),
    key: withDefault(StringParam, DEFAULT_KEY),
    clientId: withDefault(StringParam, DEFAULT_CLIENT_ID),
    /** 정렬 관련 */
    sort: withDefault(StringParam, queryParams?.sort || DEFAULT_SORT),
    sortBy: withDefault(StringParam, queryParams?.sortBy || DEFAULT_SORT_BY),
    /** 기업목록 검색 관련 */
    category: withDefault(
      StringParam,
      queryParams?.category || DEFAULT_CATEGORY
    ),
    investLevel: withDefault(
      StringParam,
      queryParams?.investLevel || DEFAULT_INVEST_LEVEL
    ),
    keyword: withDefault(StringParam, queryParams?.keyword || DEFAULT_KEYWORD),
    tag: withDefault(StringParam, queryParams?.tag || DEFAULT_TAG),
    pressType: withDefault(
      StringParam,
      queryParams?.pressType || DEFAULT_PRESS_TYPE
    ),
  });

  return {
    ...query,
    setQuery,
  };
};

export default useQueryString;
